import React, { useEffect, useState } from 'react'

import { endOfWeek, formatISO, startOfWeek, } from "date-fns"

import SeletorCliente from 'entity/Cliente/components/SeletorCliente'

import DefaultCrudForm from 'components/form/DefaultCrudForm'
import FormContent from 'components/form/FormContent'
import FormRow from 'components/form/FormRow'
import DateInput from 'components/form/input/DateInput'
import CSVButton from '../CSVButton'
import DropDownDateSelect from '../DropDownDateSelect'
import FilterButton from '../FilterButton'

import ExpandMoreIcon from "@mui/icons-material//ExpandMore"
import { Accordion, AccordionDetails, AccordionSummary, Alert, Button, Typography } from '@mui/material'
import { estatisticaCSV, getList } from 'routes/private/LaudoVisita/functions'
// import SelectInput from 'components/form/input/SelectInput'

// import _ from 'lodash'
// import { parseDuration } from 'util/datetime'

// const agrupadoresRel = [
//     { nome: "Frente", param: "frente" },
//     { nome: "Turno", param: "turno" },
//     { nome: "Equipamento", param: "equipamento" },
//     { nome: "Talhão", param: "talhao.nome" },
//     { nome: "Fazenda", param: "laudoRef.fazenda.uid", paramNameShow: "laudoRef.fazenda.codFazenda" },
//     { nome: "Insumo", param: "insumo.uid", paramNameShow: "insumo.nome" },
//     { nome: "Mês", param: "Por mês", },
// ]

function FiltrosInter(props) {
    const { laudos, setLaudos, globalLoading, setGlobalLoading, values: filters } = props
    const { dataInicio, dataFim } = props.values
    const [msgFilter, setMsgFilter] = useState("")
    const [filtersOld, setFiltersOld] = useState(filters)
    const [numLaudos, setNumLaudos] = useState(0)
    const [isExpanded,] = useState(true)

    let strAcordion = 'Filtros - Exportação de Laudos por Período'
    if (filters.cliente) {
        strAcordion = filters.cliente.nome + "- "
        strAcordion += filters.dataInicio.split("-").reverse().join("/") + " até " + filters.dataFim.split("-").reverse().join("/")
    }

    useEffect(() => {
        if (filters.cliente && laudos.length) {
            setNumLaudos(laudos.length)
        } else {
            setNumLaudos(null)
        }
    }, [laudos, filters.cliente])

    return (
        <Accordion sx={{ flex: 1 }} defaultExpanded={isExpanded}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography color="text.secondary">{strAcordion}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <FormContent sx={{ p: 1, display: "flex", justifyContent: "center", flexWrap: 'wrap' }}>
                    <FormRow>
                        <SeletorCliente sx={{ flex: 1 }} autoSelectOne required />
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <DateInput name="dataInicio" label="Data de Início" required />
                            <DateInput name="dataFim" label="Data de Fim" required />
                            <DropDownDateSelect props={props} />
                        </div>
                    </FormRow>

                    {/* <FormRow>
                        <SelectInput
                            name="agrupador"
                            label="Agrupador"
                            options={agrupadoresRel.map(t => t.nome)}
                            permiteLimpar
                        />
                    </FormRow> */}

                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 15, flexWrap: 'wrap' }}>
                        <FilterButton filters={filters} setMsgFilter={setMsgFilter} setLaudos={setLaudos} setFiltersOld={setFiltersOld} filtersOld={filtersOld} globalLoading={globalLoading} setGlobalLoading={setGlobalLoading} />

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', gap: 15, flexWrap: 'wrap' }}>
                            {laudos?.length && numLaudos !== null
                                ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 15, flexWrap: 'wrap' }}>
                                    <CSVButton startDate={dataInicio} endDate={dataFim} laudos={laudos} globalLoading={globalLoading} setGlobalLoading={setGlobalLoading} />
                                </div>
                                : null
                            }
                            {filters.cliente
                                ? ""
                                : <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={async () => await estatisticaCSV(await getList(dataInicio, dataFim))}
                                >
                                    Gerar CSV de Todos os Clientes
                                </Button>
                            }
                        </div>
                        {msgFilter ? <Alert severity="warning">{msgFilter}</Alert> : msgFilter}
                        {laudos && laudos.length && numLaudos !== null
                            ? <Typography sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled', paddingTop: '1em' }} variant="h6">Nº de Laudos: {numLaudos}</Typography>
                            : filters.cliente
                                ? <Typography sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled', paddingTop: '1em' }} variant="h6">
                                    - NENHUM LAUDO -
                                </Typography>
                                : null
                        }
                    </div>
                </FormContent >
            </AccordionDetails>
        </Accordion >
    )
}

export default function Filtros(props) {
    let dateRef = new Date();
    const di = startOfWeek(dateRef, { weekStartsOn: 0 })
    const df = endOfWeek(dateRef, { weekStartsOn: 0 })

    return (
        <DefaultCrudForm
            sxForm={{}}
            initialValues={{
                dataInicio: formatISO(di, { representation: "date" }),
                dataFim: formatISO(df, { representation: "date" })
            }}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
        >
            {(propsForm) => {
                return <FiltrosInter
                    {...props}
                    {...propsForm}
                />
            }}
        </DefaultCrudForm>
    )
}